import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from '_zari/core'

import { Divider } from '@material-ui/core'

/**
 * @param {{
 *    noMargin?: boolean
 *    variant?: 'fullWidth' | 'inset' | 'middle'
 *    title?: string
 * }} props
 * @returns {React.Component}
 */
const ZariDivider = ({ noMargin, variant, title }) => {
  return (
    <Row className={`row-divider ${noMargin ? 'no-margin' : ''}`}>
      <Col md={12}>
        {title && <h6 className='zari-divider-title'>{title}</h6>}
        <Divider variant={variant} className='mb-2' />
      </Col>
    </Row>
  )
}

ZariDivider.propTypes = {
  noMargin: PropTypes.bool,
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle']),
  title: PropTypes.string
}

ZariDivider.defaultProps = {
  variant: 'fullWidth'
}

export default React.memo(ZariDivider)
